const defaultColumnPreferences = {
};

export default defaultColumnPreferences;